module.exports = __webpack_public_path__ + "595fdf0ab81039b805da11a5889fafa3.svg";